import { SiteId } from '../../site-detail/models/Site';

export function getVideoCallToasterId(siteId: SiteId) {
    return `video-call-${siteId}`;
}
